import { createContext } from 'react'

const ActionCableConsumerContext = createContext({})
export default ActionCableConsumerContext
